import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-clients-list-skeleton',
    templateUrl: './clients-list-skeleton.component.html',
    styleUrls: ['./clients-list-skeleton.component.scss'],
    standalone: false
})
export class ClientsListSkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
